/**
 * CrewSelectionCard - Expandable card for crew assignment
 */

import React from 'react';
import { Users, ChevronDown, ChevronUp, CheckCircle } from 'lucide-react';

const CrewSelectionCard = ({ 
  crew,
  selectedCrew,
  setSelectedCrew,
  isExpanded,
  onToggle,
  isComplete
}) => {
  return (
    <div className={`rounded-lg border-2 transition-all ${
      isComplete ? 'bg-green-50 border-green-200' : 'bg-white border-gray-200'
    }`}>
      <div 
        onClick={onToggle}
        className="p-4 cursor-pointer hover:bg-gray-50 transition-colors"
      >
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <Users className={`h-5 w-5 ${isComplete ? 'text-green-600' : 'text-gray-600'}`} />
            <div>
              <h4 className="text-sm font-medium">Crew Assignment</h4>
              <p className="text-xs text-gray-500">
                {selectedCrew.length} crew members selected
              </p>
            </div>
          </div>
          <div className="flex items-center gap-2">
            {isComplete && <CheckCircle className="h-5 w-5 text-green-600" />}
            {isExpanded ? 
              <ChevronUp className="h-5 w-5 text-gray-400" /> : 
              <ChevronDown className="h-5 w-5 text-gray-400" />
            }
          </div>
        </div>
      </div>

      {isExpanded && (
        <div className="px-4 pb-4 border-t border-gray-100">
          <div className="space-y-3 mt-4">
            {crew && crew.length > 0 ? (
              <>
                <p className="text-xs text-gray-600">
                  Select crew members for this voyage. System will validate certificates automatically.
                </p>
                <div className="space-y-2 max-h-60 overflow-y-auto">
                  {crew.map((member) => (
                    <label 
                      key={member.id} 
                      className="flex items-center gap-3 p-2 rounded hover:bg-gray-50"
                    >
                      <input
                        type="checkbox"
                        checked={selectedCrew.some(c => c.id === member.id)}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setSelectedCrew(prev => [...prev, member]);
                          } else {
                            setSelectedCrew(prev => prev.filter(c => c.id !== member.id));
                          }
                        }}
                        className="rounded border-gray-300"
                      />
                      <div className="flex-1">
                        <p className="text-sm font-medium">{member.name}</p>
                        <p className="text-xs text-gray-500">{member.role || member.position}</p>
                      </div>
                      {member.certificateExpiry && (
                        <span className={`text-xs px-2 py-1 rounded ${
                          new Date(member.certificateExpiry) > new Date() 
                            ? 'bg-green-100 text-green-700' 
                            : 'bg-red-100 text-red-700'
                        }`}>
                          {new Date(member.certificateExpiry) > new Date() ? 'Valid' : 'Expired'}
                        </span>
                      )}
                    </label>
                  ))}
                </div>
              </>
            ) : (
              <p className="text-sm text-gray-500">No crew members available</p>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default CrewSelectionCard;